// Nav page list and tab helpers for AppBarHeader.
export const ALL_NAV_PAGES = [
  { labelKey: 'todaypage.title', fallback: 'Today', path: '/app/today' },
  { labelKey: 'plan.title', fallback: 'Plan', path: '/app/plan' },
  { labelKey: 'organize.title', fallback: 'Organize', path: '/app/organize' },
  {
    labelKey: 'dashboard.title',
    fallback: 'Dashboard',
    path: '/app/dashboard',
  },
];

export function getVisiblePages(isDesktop) {
  return isDesktop
    ? ALL_NAV_PAGES
    : ALL_NAV_PAGES.filter((page) => page.path !== '/app/organize');
}

export function getTabIndex(pathname, pages) {
  const idx = pages.findIndex((p) => pathname.startsWith(p.path));
  return idx >= 0 ? idx : false;
}

export function getUserInitials(displayName) {
  return displayName
    .split(/[\s@]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0].toUpperCase())
    .join('');
}
